import i18n from '../i18n';

export const LANGUAGE_LABELS = {
  en: 'English',
  hi: 'हिंदी',
};

const STORAGE_KEY = 'kisaanLang';

// Get the current saved language from localStorage
export const getSavedLanguage = () => {
  const savedLang = localStorage.getItem(STORAGE_KEY);
  return savedLang === 'en' || savedLang === 'hi' ? savedLang : 'en';
};

// Apply language selection
export const applyLanguage = (langCode, options = {}) => {
  const normalizedLang = langCode === 'en' ? 'en' : 'hi';
  const { userInitiated = false } = options;

  i18n.changeLanguage(normalizedLang);

  if (userInitiated) {
    // Optionally reload or just rely on state changes
    // window.location.reload();
  }
};

